import React, { Component } from 'react';
import { connect } from 'react-redux';  

import '../../source/style.css'
import '../../source/theme.css'
import '../../source/jatisDashboard.css'
import '../../source/FormInput.css'
import Header from './header/header'
import SideMenu from './sidebar/ItemMenu'   


class Layout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sideBarStyle: "sidebar-hide",
        };
        
        this.handleTopBarClicked = this.handleTopBarClicked.bind(this);
    }

    getTitles() { 
        if(this.props){
            if(this.props.titles){
                return this.props.titles;
            }
        }
        return [ "Home" ];
    }

    handleTopBarClicked(){
        var style = this.state.sideBarStyle;
        if(style === 'sidebar-open'){
            this.setState({sideBarStyle : 'sidebar-hide'})
        }else{
            this.setState({sideBarStyle : 'sidebar-open'})
        }
    }

    render(){
        const loaderStyle = (this.props.showLoading ? {} : { display: 'none' } );
        return(    
            <div className="sidebar--opened">  
                <div className="page-loader-wrapper" style={ loaderStyle }>
                    <div className="loader">
                        <div className="preloader">
                            <div className="spinner-layer pl-orange">
                                <div className="circle-clipper left">
                                    <div className="circle"></div>
                                </div>
                                <div className="circle-clipper right">
                                    <div className="circle"></div>
                                </div>
                            </div>
                        </div>
                        <p>Please wait...</p>
                    </div>
                </div>

                <Header handleTopBarClicked={this.handleTopBarClicked} />
                <div className="overlay"></div>

                <div className="content__main">

                    <div className={ `sidebar ${this.state.sideBarStyle}` }>
                        <div className="sidebar__container">
                            <div className="sidebar__inner">
                                <SideMenu 
                                cssClassName="sidebar-open"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="content__content">
                    
                    <div className="top-bar-breadcrumb">
                            <ol className="breadcrumb breadcrumb-bg-grey-light">
                                <li><a href="">Home</a></li>
                                <li className="active">Dashboard</li>
                            </ol>
                    </div>

                                <div class="content__inner">
                                    {this.props.children}        
                                </div>
                </div>
            </div>
        </div>
        )
    }
}

export default connect(
    (state) => {
        return {
            showLoading: state.global.showLoading,
        }
    }
)(Layout);